@if (isPermissionError) {
  <div class="col-sm-12">
    <div class="alert cds-alert alert-danger" role="alert">
      <div class="cds-alert-icon">
        <i class="fa-solid fa-triangle-exclamation"></i>
      </div>
      <div class="cds-alert-content">
        {{ "You do not have permission to access this page." | translate }}
      </div>
    </div>
  </div>
}
<appspinner [startSpinner]="nodeService.showAppLoader"></appspinner>

<h6 class="mb-1">
  {{ "Available tables for process :" | translate }}
  <h6 class="badge cds-badge active text-bg-info">
    {{ nodeService.currentProcessName }}
  </h6>
</h6>

@if (!nodeService.showAppLoader && !isPermissionError) {
  <div class="row">
    <div class="card cds-card-shadow mb-4">
      <div class="card-body">
        <div class="col-12 mb-1">
          <input
            class="form-control searchBox"
            placeholder="{{ 'Quick Filter' | translate }}"
            [(ngModel)]="searchText"
          />
        </div>
        <div class="col-sm-12">
          <table
            aria-describedby="table-proc-tablesParent"
            class="table table-striped"
            [mfData]="
              tablesData
                | filter: 'id,description,tableType,reporting' : searchText
            "
            #mf="mfDataTable"
            [mfRowsOnPage]="15"
            mfSortBy="id"
          >
            <thead>
              <tr>
                <th>
                  <mfDefaultSorter by="id">{{
                    "Code" | translate
                  }}</mfDefaultSorter>
                </th>
                <th>
                  <mfDefaultSorter by="description">{{
                    "Notes" | translate
                  }}</mfDefaultSorter>
                </th>
                <th>
                  <mfDefaultSorter by="tableType">{{
                    "Type" | translate
                  }}</mfDefaultSorter>
                </th>
                <th>
                  <mfDefaultSorter by="reporting">{{
                    "Append Mode" | translate
                  }}</mfDefaultSorter>
                </th>
              </tr>
            </thead>
            @if (tablesData.length > 0) {
              <tbody>
                @for (value of mf.data; let i = $index; track value) {
                  <tr
                    class="cursor"
                    (click)="showVariablesDetails(value, i)"
                    [ngStyle]="{
                      'background-color': i === index ? 'antiquewhite' : '',
                    }"
                  >
                    <td>{{ value.id }}</td>
                    <td>{{ value.description }}</td>
                    <td>{{ value.tableType }}</td>
                    <td>{{ value.calcMode === "APPEND" ? true : false }}</td>
                  </tr>
                }
              </tbody>
            }
            @if (
              (
                tablesData
                | filter: "id,description,tableType,reporting" : searchText
              ).length > 15
            ) {
              <tfoot>
                <tr>
                  <td colspan="10">
                    <mfBootstrapPaginator
                      [rowsOnPageSet]="[15, 50, 100]"
                    ></mfBootstrapPaginator>
                  </td>
                </tr>
              </tfoot>
            }
          </table>
        </div>
      </div>
    </div>
    @if (childTable) {
      <h6 class="mb-1">
        {{ "Details of table :" | translate }}
        <h6 class="badge cds-badge active text-bg-primary">{{ tableName }}</h6>
      </h6>
      <div class="card cds-card-shadow">
        <div class="card-body">
          <div class="col-12 text-left">
            <button
              class="btn btn-primary btn-sm m-1"
              [disabled]="false"
              (click)="exportAsXLSX()"
              title="{{ 'Export' | translate }}"
            >
              <i class="fa fa-download p-1"></i>{{ "Export" | translate }}
            </button>
            @if (notSlave) {
              <button
                class="btn btn-primary btn-sm m-1"
                [disabled]="isDisableButton()"
                (click)="openImport(templateImport)"
                title="{{ 'Import' | translate }}"
              >
                <i class="fa fa-upload p-1"></i>{{ "Import" | translate }}
              </button>
              @if (!isCutOffTable) {
                <button
                  class="btn btn-primary btn-sm m-1"
                  [disabled]="keyName && !isDisableButton() ? false : true"
                  (click)="open(template, 'Edit')"
                  title="{{ 'Edit row' | translate }}"
                >
                  <i class="fa fa-pencil p-1"></i>{{ "Edit" | translate }}
                </button>
              }
              @if (!isCutOffTable) {
                <button
                  class="btn btn-primary btn-sm m-1"
                  [disabled]="keyName && !isDisableButton() ? false : true"
                  (click)="deleteRow()"
                  title="{{ 'Delete row' | translate }}"
                >
                  <i class="fa fa-minus-circle p-1"></i
                  >{{ "Delete" | translate }}
                </button>
              }
              @if (!isCutOffTable) {
                <button
                  class="btn btn-primary btn-sm m-1"
                  [disabled]="isDisableButton()"
                  (click)="open(template, 'New')"
                  title="{{ 'Add row' | translate }}"
                >
                  <i class="fa fa-plus-circle p-1"></i>{{ "Add" | translate }}
                </button>
              }
            }
          </div>
          <!--TABLE-->
          @if (hideAndShow) {
            <div class="col-12 mt-2">
              @if (childTable && variablesData.length >= 0) {
                <div class="col-12">
                  <div class="scroll-only-x">
                    <table
                      aria-describedby="table-proc-tablesChild"
                      class="table table-striped"
                      [mfData]="variablesData"
                      #mf="mfDataTable"
                      [mfRowsOnPage]="15"
                    >
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            [attr.colspan]="inputParamData.length"
                          >
                            {{ "Input variables" | translate }}
                          </th>
                          <th
                            scope="col"
                            [attr.colspan]="outputObject.variableRefID.length"
                          >
                            {{ "Output variables" | translate }}
                          </th>
                        </tr>
                        <tr>
                          @for (prop of inputParamData; track prop) {
                            <th scope="row">
                              {{ findByName(prop.variableRefID) }}
                              {{ prop.operator | operatorPipe }}
                            </th>
                          }
                          @for (
                            prop of outputObject.variableRefID;
                            track prop
                          ) {
                            <th scope="row">
                              {{ findByName(prop.value) }}
                            </th>
                          }
                        </tr>
                        <tr>
                          @for (
                            prop of inputParamData;
                            track prop;
                            let i = $index
                          ) {
                            <th scope="row">
                              <select
                                (change)="
                                  ascAndDescOrderData(
                                    $event,
                                    i,
                                    'INPUT'
                                  )
                                "
                                [(ngModel)]="selectedOperators[i]"
                              >
                                @for (
                                  ops of operatorList;
                                  track ops;
                                  let j = $index
                                ) {
                                  <option value="{{ ops.value }}">
                                    {{ ops.viewValue }}
                                  </option>
                                }
                              </select>
                            </th>
                          }
                          @for (
                            prop of outputObject.variableRefID;
                            track prop;
                            let i = $index
                          ) {
                            <th scope="row">
                              <!-- same selectlive above without ngmodel can be used. check tfs history is needed. -->
                            </th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        @for (
                          prop of outputParamData;
                          track prop;
                          let i = $index
                        ) {
                          @if (
                            (pageNum - 1) * numOfRecordPerPage + 1 <= i + 1 &&
                            pageNum * numOfRecordPerPage > i
                          ) {
                            <tr
                              (click)="selectedRecord(i, prop)"
                              [ngStyle]="{
                                'background-color':
                                  prop.key === keyName &&
                                  !nodeService.isDisabled
                                    ? 'antiquewhite'
                                    : '',
                              }"
                            >
                              @if (prop.name.split(".").length == 1) {
                                @for (
                                  prop1 of prop.name.split(".");
                                  track prop1
                                ) {
                                  <td>
                                    {{ getValueFromName(prop1) | translate }}
                                  </td>
                                }
                              }
                              @if (prop.name.split(".").length > 1) {
                                @for (
                                  prop1 of prop.name.split(".");
                                  track prop1
                                ) {
                                  <td>
                                    {{ getValueFromName(prop1) | translate }}
                                  </td>
                                }
                              }
                              @for (
                                prop1 of prop.variableValues.variableValue;
                                track prop1
                              ) {
                                <td>
                                  {{
                                    getOutPutValue(prop1.valueState) | translate
                                  }}
                                </td>
                              }
                              <!-- rowUp(i) and rowDown(i) can be added here.-->
                            </tr>
                          }
                        }
                      </tbody>
                      @if (variablesData.length > 15) {
                        <tfoot>
                          <tr>
                            <td colspan="10" (click)="pagination()">
                              <mfBootstrapPaginator
                                [rowsOnPageSet]="[15, 50, 100]"
                              ></mfBootstrapPaginator>
                            </td>
                          </tr>
                        </tfoot>
                      }
                    </table>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}

<!-- Add/Edit Input/Output parameter for Tables -->
<ng-template #template tabindex="-1" class="modal fade cds-modal" let-modal>
  <div class="modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-1">
          {{ modelTitle }}
          <h6 class="badge cds-badge active text-bg-info m-0">
            {{ tableName }}
          </h6>
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="modal.dismiss()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="col-sm-12">
          @if (errorMsg != "") {
            <div class="alert cds-alert alert-danger col-12" role="alert">
              <div class="cds-alert-icon">
                <i class="fa-solid fa-triangle-exclamation"></i>
              </div>
              <div class="cds-alert-content">{{ errorMsg }}</div>
            </div>
          }
          <form [formGroup]="tableForm" ngNativeValidate>
            <div class="col-sm-12">
              <h6 class="heading-text">
                {{ "Input Variables" | translate }} :
              </h6>
              <hr />
            </div>
            <div class="col-sm-12">
              <div class="scroll-only-x">
                <table
                  aria-describedby="table-proc-tablesFormIp"
                  class="table table-striped"
                  [mfData]="inputMappingVariable"
                  #mf="mfDataTable"
                  [mfRowsOnPage]="15"
                >
                  <thead>
                    <tr>
                      <th>
                        <mfDefaultSorter by="">{{
                          "Variable Code" | translate
                        }}</mfDefaultSorter>
                      </th>
                      <th>
                        <mfDefaultSorter by="">{{
                          "Variable Value" | translate
                        }}</mfDefaultSorter>
                      </th>
                    </tr>
                  </thead>
                  @if (
                    inputMappingVariable.length > 0 &&
                    inputSelect.length == inputMappingVariable.length
                  ) {
                    <tbody>
                      @for (
                        value1 of inputMappingVariable;
                        track value1;
                        let i = $index
                      ) {
                        <tr>
                          <td class="col-6">{{ value1 }}</td>
                          <td>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="row">
                                  <div
                                    class="col-sm-6"
                                    (click)="updateInputFunction(i)"
                                  >
                                    <ng-select
                                      [ngModelOptions]="{ standalone: true }"
                                      [compareWith]="compareValues"
                                      (change)="
                                        setInputValue(
                                          storedInputType[i],
                                          'input',
                                          i
                                        );
                                        removeComponent(
                                          inputSelect[i],
                                          'othrInput' + i,
                                          i,
                                          'INPUT'
                                        )
                                      "
                                      placeholder="{{
                                        'Input Variables Mapping' | translate
                                      }}"
                                      [(ngModel)]="storedInputType[i]"
                                      #strInputType="ngModel"
                                      required
                                    >
                                      @for (
                                        inputMap of newInputVariable[i];
                                        track inputMap
                                      ) {
                                        <ng-option
                                          [value]="inputMap"
                                          [disabled]="
                                            newInputVariable[i].length > 5 &&
                                            inputMap === 'Values'
                                          "
                                        >
                                          {{ inputMap }}
                                        </ng-option>
                                      }
                                    </ng-select>
                                    @if (
                                      addComponentIntoList(strInputType) &&
                                      !strInputType.valid
                                    ) {
                                      <div class="cds-form-control-error">
                                        {{
                                          !strInputType.touched
                                            ? ""
                                            : ("Input value is required"
                                              | translate)
                                        }}
                                      </div>
                                    }
                                  </div>
                                  <div class="col-sm-6">
                                    @if (storedInputType[i] === "Values") {
                                      <input
                                        type="text"
                                        placeholder="{{
                                          'Input Variables Mapping' | translate
                                        }}"
                                        (keyup)="
                                          selectedValueKeyUpEvent(
                                            i,
                                            otherInput[i],
                                            'input',
                                            value1
                                          )
                                        "
                                        class="form-control"
                                        value="{{ storedInputData[i] }}"
                                        name="othrInput{{ i }}"
                                        [(ngModel)]="otherInput[i]"
                                        [ngModelOptions]="{ standalone: true }"
                                        #othrInput="ngModel"
                                        required
                                      />
                                      @if (
                                        addComponentIntoList(othrInput) &&
                                        !othrInput.valid
                                      ) {
                                        <div class="cds-form-control-error">
                                          {{
                                            !othrInput.valid && inputErrorMsg[i]
                                              ? inputErrorMsg[i]
                                              : !othrInput.touched
                                                ? ""
                                                : ("Input value is required"
                                                  | translate)
                                          }}
                                        </div>
                                      }
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  }
                </table>
              </div>
            </div>
            <div class="col-sm-12"><br /></div>
            <div class="col-sm-12">
              <h6 class="heading-text">
                {{ "Output Variables" | translate }} :
              </h6>
              <hr />
            </div>
            <div class="col-sm-12">
              <table
                aria-describedby="table-proc-tablesFormOp"
                class="table table-striped"
                [mfData]="outputMappingVariable"
                #mf="mfDataTable"
                [mfRowsOnPage]="15"
              >
                <thead>
                  <tr>
                    <th>
                      <mfDefaultSorter by="">{{
                        "Variable Code" | translate
                      }}</mfDefaultSorter>
                    </th>
                    <th>
                      <mfDefaultSorter by="">{{
                        "Variable Value" | translate
                      }}</mfDefaultSorter>
                    </th>
                  </tr>
                </thead>
                @if (
                  outputMappingVariable.length > 0 || newOutputVariable.length
                ) {
                  <tbody>
                    @for (
                      value2 of outputMappingVariable;
                      track value2;
                      let i = $index
                    ) {
                      <tr>
                        <td class="col-6">{{ value2 }}</td>
                        <td>
                          <div class="row">
                            <div class="col-12">
                              <div class="row">
                                <div
                                  class="col-sm-6"
                                  (click)="updateOutputFunction(i)"
                                >
                                  <ng-select
                                    [ngModelOptions]="{ standalone: true }"
                                    [compareWith]="compareValues"
                                    (change)="
                                      setInputValue(
                                        storedOutputType[i],
                                        'output',
                                        i
                                      );
                                      removeComponent(
                                        outputSelect[i],
                                        'othrOutput' + i,
                                        i,
                                        'OUTPUT'
                                      )
                                    "
                                    placeholder="{{
                                      'Output Variables Mapping' | translate
                                    }}"
                                    [(ngModel)]="storedOutputType[i]"
                                    #strOutputType="ngModel"
                                    required
                                  >
                                    @for (
                                      outputMap of newOutputVariable[i];
                                      track outputMap
                                    ) {
                                      <ng-option
                                        [value]="outputMap"
                                        [disabled]="
                                          newOutputVariable[i].length > 3 &&
                                          outputMap === 'Values'
                                        "
                                      >
                                        {{ outputMap }}
                                      </ng-option>
                                    }
                                  </ng-select>
                                  @if (
                                    addComponentIntoList(strOutputType) &&
                                    !strOutputType.valid
                                  ) {
                                    <div class="cds-form-control-error">
                                      {{
                                        !strOutputType.touched
                                          ? ""
                                          : ("Input value is required"
                                            | translate)
                                      }}
                                    </div>
                                  }
                                </div>
                                <div class="col-sm-6">
                                  @if (storedOutputType[i] === "Values") {
                                    <input
                                      type="text"
                                      placeholder="{{
                                        'Output Variables Mapping' | translate
                                      }}"
                                      (keyup)="
                                        selectedValueKeyUpEvent(
                                          i,
                                          $event,
                                          'output',
                                          value2
                                        )
                                      "
                                      class="form-control"
                                      value="{{ storedOutputData[i] }}"
                                      name="othrOutput{{ i }}"
                                      [(ngModel)]="otherOutput[i]"
                                      [ngModelOptions]="{ standalone: true }"
                                      #othrOutput="ngModel"
                                      required
                                    />
                                    @if (
                                      addComponentIntoList(othrOutput) &&
                                      !othrOutput.valid
                                    ) {
                                      <div class="cds-form-control-error">
                                        {{
                                          !othrOutput.valid && outputErrorMsg[i]
                                            ? outputErrorMsg[i]
                                            : !othrOutput.touched
                                              ? ""
                                              : ("Output value isrequired"
                                                | translate)
                                        }}
                                      </div>
                                    }
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-primary m-b-0"
          (click)="saveWindow()"
        >
          {{ "Save" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light m-b-0"
          (click)="cancelWindow()"
        >
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Import table -->
<ng-template
  #templateImport
  tabindex="-1"
  class="modal fade cds-modal"
  let-modal
>
  <div class="modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>
          {{ "Import the table :" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="modal.dismiss()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        @if (errorMsg != "") {
          <div class="alert cds-alert alert-danger" role="alert">
            <div class="cds-alert-icon">
              <i class="fa-solid fa-triangle-exclamation"></i>
            </div>
            <div class="cds-alert-content">{{ errorMsg | translate }}</div>
          </div>
        }
        <div class="col-sm-12"><br /></div>
        <div class="row col-sm-12">
          <h6>Choose file: &nbsp;</h6>
          <input
            #fileImport
            name="fileImport"
            type="file"
            onclick="value = null"
            (change)="fileChanged($event)"
            accept=".xls, .xlsx"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-primary m-b-0"
          (click)="importTableExcel()"
          [disabled]="isDisableImportInPopup"
        >
          {{ "Import" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light m-b-0"
          (click)="cancelWindow()"
        >
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
